import React, { useState, useEffect } from "react";
import api from "../../../requests/api";
import { useTranslation } from "react-i18next";
import { Modal, Table, Space, Button, Popconfirm, message, Input, Select, Spin } from "antd";
const { Option } = Select;
function CustomerGroups({ isModalVisible, isModalVisibleCb }) {
    const { t } = useTranslation();
    const [customerGroups, setCustomerGroups] = useState([]);
    const [selectedCustomerGroup, setSelectedCustomerGroup] = useState(null);
    const [selectedCustomerGroupId, setSelectedCustomerGroupId] = useState(null);
    const [selectedCustomers, setSelectedCustomers] = useState([]);
    const [modalState, setModalState] = useState("list");
    const [customers, setCustomers] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [customersPaginatorPage, setCustomersPaginatorPage] = useState(0);
    const [customersPaginatorHasNext, setCustomersPaginatorHasNext] = useState(false);
    const [customerSearchText, setCustomerSearchText] = useState(null);

    const [groupsPaginator, setGroupsPaginator] = useState({
        page: 0,
        amount: 8,
        hasNext: false,
        nextPage: undefined
    });

    const columns = [
        {
            title: t("customers.customerGroups.name"),
            dataIndex: "name",
            key: "name",
        },
        {
            title: t("customers.customerGroups.customers"),
            dataIndex: "customers",
            key: "customers",
            render: (item) => (item ? item.length : 0),
        },
        {
            title: t("customers.customerGroups.actions"),
            dataIndex: "actions",
            key: "actions",
            render: (item, row) => (
                <Space>
                    <Button onClick={() => setSelectedCustomerGroupId(row.id)}>
                        {" "}
                        {t("customers.customerGroups.edit")}{" "}
                    </Button>
                    <Popconfirm
                        title={t("customers.customerGroups.deleteConfirmation")}
                        onConfirm={() => confirmDelete(row.id)}
                        okText={t("customers.customerGroups.yes")}
                        cancelText={t("customers.customerGroups.no")}
                    >
                        <Button danger> {t("customers.customerGroups.delete")} </Button>
                    </Popconfirm>
                </Space>
            ),
        },
    ];
    const confirmDelete = (id) => {
        setIsLoading(true);
        api.customers()
            .deleteGroup(id)
            .then((res) => {
                const updatedGroups = customerGroups.filter((customerGroup) => customerGroup.id !== id);
                setCustomerGroups(
                    customerGroups.filter((customerGroup) => customerGroup.id !== id)
                );
                if (updatedGroups.length === 0 && groupsPaginator.page > 1) {
                    const previousPage = groupsPaginator.page - 1;
                    loadCustomerGroups(previousPage - 1, groupsPaginator.pageSize);
                } else {
                    const currentItems = updatedGroups.length;
                    const currentPageIndex = groupsPaginator.page - 1;
                    const estimatedTotal = groupsPaginator.hasNext 
                        ? (groupsPaginator.page * groupsPaginator.pageSize) + 1
                        : (currentPageIndex * groupsPaginator.pageSize) + currentItems;
                    
                    setGroupsPaginator(prev => ({
                        ...prev,
                        total: estimatedTotal
                    }));
                }
                setIsLoading(false);
                message.success("Deleted");
            })
            .catch((err) => {
                console.log(err);
            });
    };
    const loadCustomerGroup = (id) => {
        setIsLoading(true);
        api.customers()
            .group(id)
            .then((res) => {
                const customerGroup = { ...res.data, customersId: res.data.customers };
                setCustomers(customerGroup.customers);
                setSelectedCustomers(customerGroup.customers.map((customer) => customer.id));
                setModalState("edit");
                setSelectedCustomerGroup(res.data);
                setIsLoading(false);
            });
    };
    const searchCustomer = (text) => {
        setCustomersPaginatorPage(0);
        setCustomerSearchText(text);
    };
    function handleCustomersPopupScroll(e) {
        e.persist();
        let target = e.target;
        if (target.scrollTop + target.offsetHeight === target.scrollHeight) {
            if (customersPaginatorHasNext) {
                setCustomersPaginatorPage((customersPaginatorPage) => customersPaginatorPage + 1);
            }
        }
    }
    const resetState = () => {
        setSelectedCustomerGroupId(null);
        setSelectedCustomerGroup(null);
        setSelectedCustomers([]);
        isModalVisibleCb(false);
    };
    const closeModal = () => {
        setModalState("list");
        resetState();
    };
    const viewNewGroup = () => {
        setModalState("create");
        setSelectedCustomerGroup({ name: "", customersId: [] });
    };
    const handleInput = (e) => {
        setSelectedCustomerGroup({
            ...selectedCustomerGroup,
            name: e.target.value,
        });
    };
    const handleSelect = (list) => {
        setSelectedCustomers(list);
    };
    const saveChanges = () => {
        const group = { ...selectedCustomerGroup, customersId: selectedCustomers };
        setIsLoading(true);
        if (modalState === "create") {
            api.customers()
                .createGroup(group)
                .then((res) => {
                    message.success(t("customers.customerGroups.groupCreated"));
                })
                .catch((err) => {
                    message.error(err.response?.data?.error?.message);
                });
        } else if (modalState === "edit") {
            api.customers()
                .editGroup(group)
                .then((res) => {
                })
                .catch((err) => {
                    console.log(err);
                });
            message.success(t("customers.customerGroups.groupUpdated"));
        }
        closeModal();
    };

    const loadCustomerGroups = (page = 0, amount = 8) => {
        setIsLoading(true);
        api.customers()
            .groups(page, amount)
            .then((res) => {
                setCustomerGroups(res.data.customerGroups);

                const currentPage = page + 1;
                const currentItems = res.data.customerGroups.length;
                const estimatedTotal = res.data.paginator.hasNext 
                    ? (currentPage * amount) + 1
                    : (currentPage - 1) * amount + currentItems;
                

                setGroupsPaginator({
                    page: page + 1,
                    pageSize: amount,
                    hasNext: res.data.paginator.hasNext,
                    nextPage: res.data.paginator.nextPage,
                    total: estimatedTotal
                });
                setIsLoading(false);
            })
            .catch((err) => {
                console.log(err);
                setIsLoading(false);
            });
    };

    const handleTableChange = (pagination) => {
        loadCustomerGroups(pagination.current - 1, pagination.pageSize);
    };

    useEffect(() => {
        if (isModalVisible) {
            loadCustomerGroups();
        }
    }, [isModalVisible]);
    useEffect(() => {
        if (selectedCustomerGroupId) {
            loadCustomerGroup(selectedCustomerGroupId);
        } else if (selectedCustomerGroupId === "create") {
            setSelectedCustomerGroup({ name: "", customersId: [] });
        }
    }, [selectedCustomerGroupId]);
    useEffect(() => {
        setIsLoading(true);
        api.customers()
            .list(customersPaginatorPage, customerSearchText, null, null, null)
            .then((res) => {
                if (customersPaginatorPage === 0) {
                    setCustomers(res.data.customers);
                } else {
                    setCustomers((customers) => [...customers, ...res.data.customers]);
                }
                setCustomersPaginatorHasNext(res.data.paginator.hasNext);
                setIsLoading(false);
            });
    }, [customersPaginatorPage, customerSearchText]);
    return (
        <Modal
            title={t("customers.customerGroups.manageCustomerGroups")}
            visible={isModalVisible}
            onCancel={() => closeModal()}
            footer={[
                modalState === "edit" || modalState === "create" ? (
                    <>
                        <Button
                            onClick={() => {
                                setModalState("list");
                                setSelectedCustomerGroupId(null);
                            }}
                        >
                            {" "}
                            {t("customers.customerGroups.back")}{" "}
                        </Button>
                        <Button
                            onClick={saveChanges}
                            type="primary"
                            disabled={selectedCustomerGroup?.name ? false : true}
                        >
                            {" "}
                            {t("customers.customerGroups.save")}{" "}
                        </Button>
                    </>
                ) : (
                    <Button onClick={closeModal}> {t("customers.customerGroups.close")} </Button>
                ),
            ]}
        >
            <Spin spinning={isLoading}>
                {(modalState === "edit" || modalState === "create") && selectedCustomerGroup ? (
                    <>
                        <label>{t("customers.customerGroups.name")}</label>
                        <Input
                            value={selectedCustomerGroup && selectedCustomerGroup.name}
                            placeholder={t("customers.customerGroups.customerGroupNamePlaceholder")}
                            style={{ marginBottom: "10px" }}
                            onChange={handleInput}
                        />
                        <label>{t("customers.customerGroups.customers")}</label>
                        <Select
                            mode="multiple"
                            showSearch
                            filterOption={false}
                            style={{ width: "100%" }}
                            placeholder={t("customers.customerGroups.searchCustomersPlaceholder")}
                            value={selectedCustomers}
                            onSearch={searchCustomer}
                            onChange={handleSelect}
                            onPopupScroll={handleCustomersPopupScroll}
                        >
                            {customers &&
                                customers.map((item) => (
                                    <Option value={item.id}>
                                        {item.fullName} {item.phone}{" "}
                                    </Option>
                                ))}
                        </Select>
                    </>
                ) : (
                    <>
                        <div style={{ display: "flex", justifyContent: "flex-end" }}>
                            <Button
                                type="primary"
                                style={{ marginBottom: "10px" }}
                                onClick={viewNewGroup}
                            >
                                {t("customers.customerGroups.create")}
                            </Button>
                        </div>
                        <Table 
                            dataSource={customerGroups} 
                            columns={columns} 
                            pagination={{
                                current: groupsPaginator.page,
                                pageSize: groupsPaginator.pageSize,
                                total: groupsPaginator.total,
                                hideOnSinglePage: false,
                            }}
                            onChange={handleTableChange}
                        />
                    </>
                )}
            </Spin>
        </Modal>
    );
}
export default CustomerGroups;
